import Enum from './Enum.js';

export default class CampaignObjective extends Enum {
    static get entries() {
        return {
            appointment: 'appointment_date',
            sale: 'sale_date',
            roadTest: 'road_test_date',
            visit: 'presented_date',
            no_objective: null,
        };
    }

    static get APPOINTMENT() {
        return this.entries.appointment;
    }

    static get SALE() {
        return this.entries.sale;
    }

    static get ROAD_TEST() {
        return this.entries.roadTest;
    }

    static get VISIT() {
        return this.entries.visit;
    }

    static get NONE() {
        return this.entries.none;
    }

    static get translationGroup() {
        return 'campaignObjective';
    }
}
